import { combineActions, handleActions } from 'redux-actions'

import { resetContentState } from '@tabeeb/modules/shared/content/actions'
import * as rawActions from '../actions'

const defaultState = {
  Id: null,
}

export default handleActions(
  {
    [rawActions.selectContentTrashBinFolder](state, action) {
      return action.payload
    },
    [combineActions(rawActions.deselectContentTrashBinFolder, resetContentState)](state, action) {
      return defaultState
    },
  },
  defaultState
)
